// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Leave Balance Dashboard CSS */

.leave-summary-container {
    display: block;
    justify-content: center;
    align-items: center;
    padding: 20px;
    padding-bottom: 10px;
  }
  
  .leave-summary-dashboard {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
    background: white;
    padding: 18px;
    border-radius: 20px;
    width: 100%;
    border: 3px solid #ddd;
  }
  
  .leave-summary-card {
    border-radius: 8px;
    text-align: center;
    background: white;
    position: relative;
  }
  
  .leave-summary-circle {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    position: absolute;
    top: 1px;
    right: -12px;
    transform: translateX(-50%);
  }
  
  .brown {
    background-color: #a87b65;
  }
  
  .yellow {
    background-color: #f4c542;
  }
  
  .green {
    background-color: #66bb6a;
  }
  
  .light-gray {
    background-color: #e0e0e0;
  }

  .text-brown {
    color: #a87b65;
  }
  
  .text-yellow {
    color: #f4c542;
  }
  
  .text-green {
    color: #28a745;
  }

  .text-gray {
    color: #666;
  }

  .text-light-gray {
    color: #e0e0e0;
  }

  .text-red {
    color: #c9110b;
  }
  
  .leave-summary-line {
    width: 2px;
    height: 100%;
    background-color: #ccc;
    position: absolute;
    top: 0px;
    right: -6%;
    transform: translateX(-109%);
  }
  
  .leave-summary-title {
    font-size: 16px;
    color: #666;
    margin-top: 5px;
    margin-bottom: 5px;
    padding-right: 32px;
  }
  
  .leave-summary-days {
    font-size: 25px;
    font-weight: bold;
    color: #333;
    margin-top: 10px;
    margin-bottom: 0px;
  }
  
  .leave-summary-subtext {
    font-size: 14px;
    color: #000;
    margin-top: 0px;
    margin-bottom: 8px;
  }
  
  .leave-summary-highlight {
    font-size: 14px;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  
  .leave-summary-warning {
    font-size: 12px;
    color: #d9534f;
    font-weight: bold;
  }
  
  .leave-summary-small-text {
    font-size: 14px;
    color: #999;
  }

  .leave-summary-desc {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
    padding: 5px 18px;
    width: 100%;
    color: #999;
  }

  .leave-summary-desc-text {
    text-align: center;
    position: relative;
    font-size: 12px;
  }

  .leave-summary-bottom {
    display: table;
    width: 100%;
    margin-top: 20px;
    padding-bottom: 20px;
    border-bottom: 2px dashed #ece7e7;
  }

  .leave-summary-bottom #btn-request-compensation {
      float: right;
      background: #fff;
      border: 2px solid #26a69a;
      color: #26a69a;
      text-transform: none;
      line-height: 30px;
      padding-left: 8px;
      padding-right: 8px;
      margin-left: 12px;
  }
  .leave-summary-bottom #btn-create-new {
      float: right;
      text-transform: none;
      line-height: 30px;
      padding-left: 8px;
      padding-right: 8px;
      margin-left: 0px;
  }
  .leave-summary-bottom div:nth-child(2) {
      float: left;
      margin-right: 15px;
      line-height: 36px;
  }
  .leave-summary-bottom div:nth-child(1) {
      float: left;
      margin-right: 15px;
      line-height: 36px;
  }
  .leave-summary-bottom .title{
      font-weight: bold;
      margin-right: 5px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Container/top.content.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;IACI,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,iCAAiC;EACnC;;EAEA;MACI,YAAY;MACZ,gBAAgB;MAChB,yBAAyB;MACzB,cAAc;MACd,oBAAoB;MACpB,iBAAiB;MACjB,iBAAiB;MACjB,kBAAkB;MAClB,iBAAiB;EACrB;EACA;MACI,YAAY;MACZ,oBAAoB;MACpB,iBAAiB;MACjB,iBAAiB;MACjB,kBAAkB;MAClB,gBAAgB;EACpB;EACA;MACI,WAAW;MACX,kBAAkB;MAClB,iBAAiB;EACrB;EACA;MACI,WAAW;MACX,kBAAkB;MAClB,iBAAiB;EACrB;EACA;MACI,iBAAiB;MACjB,iBAAiB;EACrB","sourcesContent":["/* Leave Balance Dashboard CSS */\r\n\r\n.leave-summary-container {\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 20px;\r\n    padding-bottom: 10px;\r\n  }\r\n  \r\n  .leave-summary-dashboard {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    gap: 15px;\r\n    background: white;\r\n    padding: 18px;\r\n    border-radius: 20px;\r\n    width: 100%;\r\n    border: 3px solid #ddd;\r\n  }\r\n  \r\n  .leave-summary-card {\r\n    border-radius: 8px;\r\n    text-align: center;\r\n    background: white;\r\n    position: relative;\r\n  }\r\n  \r\n  .leave-summary-circle {\r\n    width: 25px;\r\n    height: 25px;\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    top: 1px;\r\n    right: -12px;\r\n    transform: translateX(-50%);\r\n  }\r\n  \r\n  .brown {\r\n    background-color: #a87b65;\r\n  }\r\n  \r\n  .yellow {\r\n    background-color: #f4c542;\r\n  }\r\n  \r\n  .green {\r\n    background-color: #66bb6a;\r\n  }\r\n  \r\n  .light-gray {\r\n    background-color: #e0e0e0;\r\n  }\r\n\r\n  .text-brown {\r\n    color: #a87b65;\r\n  }\r\n  \r\n  .text-yellow {\r\n    color: #f4c542;\r\n  }\r\n  \r\n  .text-green {\r\n    color: #28a745;\r\n  }\r\n\r\n  .text-gray {\r\n    color: #666;\r\n  }\r\n\r\n  .text-light-gray {\r\n    color: #e0e0e0;\r\n  }\r\n\r\n  .text-red {\r\n    color: #c9110b;\r\n  }\r\n  \r\n  .leave-summary-line {\r\n    width: 2px;\r\n    height: 100%;\r\n    background-color: #ccc;\r\n    position: absolute;\r\n    top: 0px;\r\n    right: -6%;\r\n    transform: translateX(-109%);\r\n  }\r\n  \r\n  .leave-summary-title {\r\n    font-size: 16px;\r\n    color: #666;\r\n    margin-top: 5px;\r\n    margin-bottom: 5px;\r\n    padding-right: 32px;\r\n  }\r\n  \r\n  .leave-summary-days {\r\n    font-size: 25px;\r\n    font-weight: bold;\r\n    color: #333;\r\n    margin-top: 10px;\r\n    margin-bottom: 0px;\r\n  }\r\n  \r\n  .leave-summary-subtext {\r\n    font-size: 14px;\r\n    color: #000;\r\n    margin-top: 0px;\r\n    margin-bottom: 8px;\r\n  }\r\n  \r\n  .leave-summary-highlight {\r\n    font-size: 14px;\r\n    margin-top: 5px;\r\n    margin-bottom: 5px;\r\n  }\r\n  \r\n  .leave-summary-warning {\r\n    font-size: 12px;\r\n    color: #d9534f;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .leave-summary-small-text {\r\n    font-size: 14px;\r\n    color: #999;\r\n  }\r\n\r\n  .leave-summary-desc {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    gap: 15px;\r\n    padding: 5px 18px;\r\n    width: 100%;\r\n    color: #999;\r\n  }\r\n\r\n  .leave-summary-desc-text {\r\n    text-align: center;\r\n    position: relative;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .leave-summary-bottom {\r\n    display: table;\r\n    width: 100%;\r\n    margin-top: 20px;\r\n    padding-bottom: 20px;\r\n    border-bottom: 2px dashed #ece7e7;\r\n  }\r\n\r\n  .leave-summary-bottom #btn-request-compensation {\r\n      float: right;\r\n      background: #fff;\r\n      border: 2px solid #26a69a;\r\n      color: #26a69a;\r\n      text-transform: none;\r\n      line-height: 30px;\r\n      padding-left: 8px;\r\n      padding-right: 8px;\r\n      margin-left: 12px;\r\n  }\r\n  .leave-summary-bottom #btn-create-new {\r\n      float: right;\r\n      text-transform: none;\r\n      line-height: 30px;\r\n      padding-left: 8px;\r\n      padding-right: 8px;\r\n      margin-left: 0px;\r\n  }\r\n  .leave-summary-bottom div:nth-child(2) {\r\n      float: left;\r\n      margin-right: 15px;\r\n      line-height: 36px;\r\n  }\r\n  .leave-summary-bottom div:nth-child(1) {\r\n      float: left;\r\n      margin-right: 15px;\r\n      line-height: 36px;\r\n  }\r\n  .leave-summary-bottom .title{\r\n      font-weight: bold;\r\n      margin-right: 5px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
